import { useQuery } from '@tanstack/react-query';
import api from '../../api';
import { type Payment } from '../../types/api/payment';

type PaymentQueryKey = ['payments', string];

export function usePollPaymentQuery(paymentId: string | null, shouldPoll: boolean, interval: number) {
  return useQuery<Payment, Error, Payment, PaymentQueryKey>({
    queryKey: ['payments', paymentId!],
    queryFn: () => api.payment.get(paymentId!),
    enabled: Boolean(paymentId),
    refetchInterval: shouldPoll && interval,
  });
}
